var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bottom-sheet',{attrs:{"title":_vm.detail.title,"showing":_vm.detail.show},on:{"on-close":function($event){return _vm.$emit('on-close')}}},[_c(_vm.comp,{tag:"component",attrs:{"data":_vm.detail.data,"relation":_vm.detail.item}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }